import { createTheme } from "@mui/material";
import { colors } from "./colors";
import "./commissioner.d.ts";
import "@fontsource-variable/commissioner";
import "./theme.module.css";

/**
 * @public Used in MDX file that knip can't find
 */
export const palette = {
  primary: {
    main: colors.brand.majorelleBlue,
    dark: colors.brand.pennBlue,
    light: colors.brand.jordyBlue,
    contrastText: colors.brand.whiteSmoke,
  },
  secondary: {
    main: colors.brand.tiffanyBlue,
    contrastText: colors.brand.pennBlue,
  },
  background: {
    default: colors.brand.whiteSmoke,
    paper: colors.brand.magnolia,
  },
  text: {
    primary: colors.brand.pennBlue,
    secondary: colors.greys.darkGray,
  },
  error: {
    main: colors.brand.faluRed,
    dark: colors.brand.faluRed,
  },
  warning: {
    main: colors.brand.sahara,
    light: colors.brand.goldenrod,
  },
  success: {
    main: colors.brand.treeGreen,
    light: colors.brand.lightGreyGreen,
  },
};

export const lightTheme = createTheme({
  palette,
  typography: {
    fontFamily: [
      "Helvetica Neue",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Arial",
      "sans-serif",
    ].join(","),
    h1: {
      fontFamily: "Commissioner Variable",
      fontSize: "72px",
      lineHeight: "84px",
    },
    h2: {
      fontFamily: "Commissioner Variable",
      fontSize: "66px",
      lineHeight: "78px",
    },
    h3: {
      fontFamily: "Commissioner Variable",
      fontSize: "40px",
      lineHeight: "52px",
    },
    h4: {
      fontFamily: "Commissioner Variable",
      fontSize: "24px",
      lineHeight: "32px",
    },
    body1: {
      fontFamily: [
        "Helvetica Neue",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Arial",
        "sans-serif",
      ].join(","),
      fontSize: "18px",
      lineHeight: "28px",
    },
    body2: {
      fontFamily: [
        "Helvetica Neue",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Arial",
        "sans-serif",
      ].join(","),
      fontSize: "12px",
      lineHeight: "18px",
    },
  },
});
